"use client";

import { useEffect } from "react";
import { MEASUREMENT_CONSENT_EVENT, syncOpenaiConsent } from "@/lib/analytics/openaiPixel";

export default function OpenaiPixel() {
    useEffect(() => {
        syncOpenaiConsent();
        window.addEventListener(MEASUREMENT_CONSENT_EVENT, syncOpenaiConsent);
        window.addEventListener("storage", syncOpenaiConsent);
        return () => {
            window.removeEventListener(MEASUREMENT_CONSENT_EVENT, syncOpenaiConsent);
            window.removeEventListener("storage", syncOpenaiConsent);
        };
    }, []);
    return null;
}
